export const SCHOOL_INQUIRY_PAGE_COUNT = 10;